import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BASE_URL, END_POINTS } from '../utility/APIConstants';

@Injectable({
  providedIn: 'root'
})
export class ExportcsvService {
  constructor(private _http: HttpClient) { }

  public export(module: string){
    return this._http.get(BASE_URL + END_POINTS.EXPORT_CSV.EXPORT(module), { responseType: 'blob' });
}


exportSubContractor() {
        return this._http.get(BASE_URL + END_POINTS.EXPORT_CONTRACTORWO.EXPORT);
      }
}
